import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const CONTACT = "admin@pinscher-botb.com";

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className={`nav${scrolled ? " scrolled" : ""}`}>
      <div className="container nav-inner">
        <Link to="/" className="brand" aria-label="PINSCHER home">
          <img className="brand-mark" src="/pinscher-mark.png" alt="" width="56" height="37" />
          <span className="word">PINSCHER</span>
        </Link>

        <nav className="nav-links">
          <Link to="/#approach">Approach</Link>
          <Link to="/#defcon">Battle of the Bots</Link>
          <Link to="/#how">Technology</Link>
          <NavLink to="/investors" className={({ isActive }) => (isActive ? "active" : "")}>
            Investors
          </NavLink>
        </nav>

        <div className="nav-actions">
          <a className="btn btn-primary btn-sm" href={`mailto:${CONTACT}?subject=PINSCHER%20inquiry`}>
            Get in touch
          </a>
          <button
            className="nav-toggle"
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {open ? <path d="M18 6 6 18M6 6l12 12" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
            </svg>
          </button>
        </div>
      </div>

      <div className={`mobile-menu${open ? " open" : ""}`}>
        <Link to="/#approach">Approach</Link>
        <Link to="/#defcon">Battle of the Bots</Link>
        <Link to="/#how">Technology</Link>
        <Link to="/investors">Investors</Link>
        <a className="btn btn-primary" href={`mailto:${CONTACT}?subject=PINSCHER%20inquiry`}>
          Get in touch
        </a>
      </div>
    </header>
  );
}
